import { BrandWordmark } from "@/components/brand/BrandWordmark";
import { Loader } from "@/components/kit";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="brand-paper-bg flex h-svh items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="brand-paper-bg flex min-h-svh">
      {/* Hero — แบรนด์และข้อความต้อนรับ */}
      <div className="relative hidden flex-col justify-between overflow-hidden border-secondary/20 border-r bg-card/40 p-10 lg:flex lg:w-[44%] xl:w-[42%]">
        <div
          className="pointer-events-none absolute top-20 -left-16 size-56 rounded-full bg-primary/15 blur-3xl"
          aria-hidden
        />
        <div
          className="pointer-events-none absolute -right-10 bottom-24 size-48 rounded-full bg-leaf/15 blur-3xl"
          aria-hidden
        />

        <BrandWordmark size="lg" className="relative z-10 pt-4" />

        <div className="relative z-10 flex flex-col gap-4">
          <p className="max-w-sm font-display text-2xl text-foreground leading-snug">
            ຍິນດີຕ້ອນຮັບກັບຄືນ
          </p>
          <p className="max-w-sm text-muted-foreground text-sm leading-relaxed">
            ລະບົບຈັດການສຳລັບ Sunlower Supplies — ສິນຄ້າຫັດຖະກຳ, ອຸປະກອນທຳສວນ ແລະ
            ວັດຖຸດິບທຳມະຊາດ
          </p>
          <div className="flex items-center gap-2 font-semibold text-secondary text-xs uppercase tracking-[0.2em]">
            <span className="h-px w-6 bg-secondary/50" />
            <span>ປົກກະຕິ · ອົບອຸ່ນ · ເປີດໃຈ</span>
            <span className="h-px w-6 bg-secondary/50" />
          </div>
        </div>

        <p className="relative z-10 text-muted-foreground text-xs">
          © Sunlower Supplies
        </p>
      </div>

      {/* ฟอร์ม login */}
      <div className="flex flex-1 flex-col items-center justify-center p-6 sm:p-10">
        <div className="mb-8 flex flex-col items-center gap-3 lg:hidden">
          <BrandWordmark size="md" />
        </div>
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
